import {
  Text,
  VStack,
  HStack,
  ScrollView,
  Pressable
} from "@gluestack-ui/themed";

import { ButtonGroup } from "@repo/core/components/core/ButtonGroup";
import { Icon } from "@repo/core/components/core/Icon";

import { Input } from "@repo/core/components/core/Input";

import { filterStatusOptions } from "./consts";
import { ProposalsSearchHeaderProps } from "./types";
import { applyCpfMaskProgressive } from "@repo/core/utils/mask.utils";
import { getCpfSearchKeyboardType } from "../../utils";
import { useMemo } from "react";
import { useDimensions } from "@repo/core/hooks/useDimensions";

export const ProposalsHeader = ({
  onRefresh,
  updatedText,
  searchText,
  setSearchText,
  selectedCategory,
  setSelectedCategory,
  hideStatusFilters
}: ProposalsSearchHeaderProps) => {
  const { isMobile, isTablet } = useDimensions();

  const inputSearchRightIcon = {
    name: "magnifying-glass",
    onPress: () => {
      setSearchText(searchText);
    }
  };

  const handleSearchChange = (value: string) => {
    setSearchText(applyCpfMaskProgressive(value));
  };

  const headerContentWidth = useMemo(() => {
    if (isTablet) return "80%";
    if (isMobile) return "$full";

    return "$full";
  }, [isMobile, isTablet]);

  return (
    <VStack
      width="$full"
      alignItems="center"
      justifyContent="center"
      py="$6"
      px="$4"
      bg="$primary700"
    >
      <VStack
        w={headerContentWidth}
        alignItems="center"
        justifyContent="center"
        gap="$4"
      >
        <HStack>
          <Text color="$textLight50" fontWeight={500} fontSize="$lg">
            Propostas
          </Text>
        </HStack>
        <HStack
          flex={1}
          alignItems="center"
          justifyContent="center"
          w={isMobile ? "$full" : "40%"}
          // TODO: Add px="$8" when the API return the type of the proposal
          gap="$2"
        >
          <Input
            light
            width="$full"
            showClear
            enlargeClearButton
            name="search"
            mask="cpf"
            useMaskValue
            maxLength={14}
            keyboardType={getCpfSearchKeyboardType()}
            inputMode="numeric"
            autoCorrect={false}
            autoComplete="off"
            textContentType="none"
            importantForAutofill="no"
            value={searchText}
            onClear={() => setSearchText("")}
            onChange={handleSearchChange}
            onKeyPress={(e) => {
              // NOTE: When pressed Enter on web
              if (e.keyCode === 13) {
                setSearchText(searchText);
              }
            }}
            onSubmitEditing={() => {
              // NOTE: When pressed Done/Finish on mobile
              setSearchText(searchText);
            }}
            returnKeyType="done"
            rightIcon={searchText ? undefined : inputSearchRightIcon}
            placeholder="Buscar por CPF"
          />

          {/*    <Button
            variant="outline"
            borderColor="#FFFFFF50"
            $hover-backgroundColor="$primary800"
            $hover-BorderColor="$white"
            $focus-backgroundColor="$primary800"
            $focus-BorderColor="$white"
            $pressed-backgroundColor="$primary800"
            $pressed-BorderColor="$white"
            onPress={onFilterPress}
            w={isTablet ? "$fit-content" : "$12"}
            p="$1"
            h="$12"
          >
            {!isMobile ? (
              <Pressable onPress={onFilterPress} m="$0" p="$0">
                <ButtonIcon
                  name="filter"
                  size={filtersCount ? 22 : 18}
                  color="$white"
                  variant={filtersCount ? "solid" : "regular"}
                />
              </Pressable>
            ) : (
              <ButtonIcon
                name="filter"
                size={filtersCount ? 22 : 18}
                color="$white"
                variant={filtersCount ? "solid" : "regular"}
              />
            )}
            {filtersCount ? (
              <Badge
                alignItems="center"
                justifyContent="center"
                position="absolute"
                borderColor="$primary700"
                right={isTablet ? 16 : 6}
                bottom={8}
                bg="$white"
                px={5}
                rounded="$full"
                zIndex={1}
                size="sm"
                variant="solid"
              >
                <BadgeText color="$secondary800" fontSize={9}>
                  {filtersCount}
                </BadgeText>
              </Badge>
            ) : null}
          </Button> */}
        </HStack>
        {!hideStatusFilters ? (
          <HStack width={isMobile ? "$full" : undefined} maxWidth="$full">
            <ScrollView
              horizontal
              showsHorizontalScrollIndicator={false}
              contentContainerStyle={{
                paddingHorizontal: isMobile ? 0 : 8,
                alignItems: "center"
              }}
              style={{
                maxWidth: "100%",
                flexGrow: 0
              }}
            >
              <ButtonGroup
                type="primary"
                onChange={(value) => setSelectedCategory(value)}
                options={filterStatusOptions}
                value={selectedCategory}
              />
            </ScrollView>
          </HStack>
        ) : null}
        <HStack alignItems="center" justifyContent="center" gap="$2">
          <Text fontSize="$2xs" color="$primary50" fontWeight={400}>
            {updatedText}
          </Text>
          <Pressable onPress={onRefresh}>
            <Icon name="refresh" color="white" size={16} />
          </Pressable>
        </HStack>
      </VStack>
    </VStack>
  );
};
